<template>

	<div>
		<van-nav-bar title="小程序回复" left-text="返回" left-arrow fixed placeholder @click-left="goBack" v-show="this.$UserAgent.indexOf('Html5Plus')==-1?true:false" />
		<van-button type="info" size="large" @click="add" style="position: fixed;bottom: 0;z-index: 1;" v-if="datas.length">添加</van-button>

		<van-empty description="什么都没有" image="search" v-if="!datas.length && show_empty">
			<van-button round type="info" class="bottom-button" @click="add">
				添加
			</van-button>
		</van-empty>

        <van-panel style="margin: 10px;border-radius: 10px;box-shadow: 0 0.02rem 0.06rem 0 rgba(24, 107, 198, 0.3);"
		 v-for="(item, index) in datas" :key="index" :title="'关键词【' + item.keyword + '】'" :status="item.switch_checked?'状态：正常':'状态：关闭'">
			<div style="padding: 20px;">
				<div>小程序({{item.title}})</div>
			</div>
			<template #footer>
				<van-button size="small" type="info" @click="edit(index)">修改</van-button>
				&nbsp;
				<van-button size="small" type="danger" @click="del(index)">删除</van-button>
			</template>
		</van-panel>


		<van-popup v-model="show_add" closeable round :style="{ height: '5rem', width: '95%' }">
			<div style="padding: 30px 10px 0 10px;">
				<van-form @submit="onSubmitPic">
					<van-field v-model="keyword" label="关键词:" name="keyword" placeholder="在这里输入关键词" :rules="[{ required: true, message: '请填写关键词' }]" show-word-limit maxlength="10" />
					<van-field v-model="title" label="标题:" name="title" placeholder="在这里输入小程序标题" :rules="[{ required: true, message: '请填写小程序标题' }]" show-word-limit maxlength="10" />
					<van-field v-model="mini_id" label="原始ID:" name="mini_id" placeholder="如: gh_12d3d5656d10" :rules="[{ required: true, message: '请填写小程序原始ID' }]" show-word-limit maxlength="20" />
					<van-field label="图标:" name="pic_files">
						<template #input>
							<van-uploader v-model="pic_files" :max-count="1" :before-read="beforeRead" :max-size="2 * 1024 * 1024"
							 @oversize="overZize" />
						</template>
					</van-field>
		
		
					<van-field name="switch_checked" label="启用">
						<template #input>
							<van-switch v-model="switch_checked" size="20" />
						</template>
					</van-field>
					
					<van-field name="is_match" label="精确匹配">
						<template #input>
							<van-switch v-model="is_match" size="20" />
						</template>
					</van-field>
		
					<div style="margin: 16px;">
						<van-button round block type="info" native-type="submit">
							提交
						</van-button>
					</div>
				</van-form>
			</div>
		</van-popup>
		<div style="height: 100px;"></div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				op: 'mini',
				switch_checked: true,
				is_match: false,

				show_add: false,
				pic_files: [],
				keyword: '',
				title: '',
				mini_id: '',


				datas: [],

				edit_id: 0,

				show_empty: false
			}
		},
		created() {
			var group_id = localStorage.getItem('select_id')
			if (!group_id) {
				this.$router.push('/member-center')
				return;
			}
			this.group_id = group_id

			this.get()
		},
		methods: {
			add() {
				this.show_add = true
			},
			edit(e) {
				var id = this.datas[e].id
				var type = this.datas[e].type

				this.$ApiUtil.GroupCenterSrc.find({
					id: id
				}).then(res => {
					
					this.keyword = res.data.keyword
					var list = res.data.pic_files
					this.pic_files = list
					this.show_add = true
					
					this.title = res.data.title
					this.mini_id = res.data.mini_id

					this.switch_checked = res.data.switch_checked
					this.is_match = res.data.is_match

					this.edit_id = id

				})
			},
			del(e) {
				this.$dialog.confirm({
					message: '确认删除吗?'
				}).then(() => {
					var id = this.datas[e].id
					this.$ApiUtil.GroupCenterSrc.del({
						id: id
					}).then(res => {
						this.$toast.success(res.message)
						this.get()
					})
				})

			},
			beforeRead(file) {
				if (file.type.indexOf('image') === -1) {
					this.$toast.fail('请上传图标文件');
					return false;
				}
				return true;
			},
			overZize(file) {
				this.$toast.fail('文件超过2M啦')
			},
			get() {
				this.$ApiUtil.GroupCenterSrc.get({
					a: this.group_id,
					v: this.op
				}).then(res => {
					this.datas = res.data
					this.show_empty = true
				})
			},
			submit(values) {
				if(this.pic_files.length <= 0){
					this.$toast.fail('请上传图标')
					return
				}
				console.log(values)
				values.type = 'mini'
				this.$ApiUtil.GroupCenterSrc.post({
					op: this.op,
					id: this.group_id,
					values: JSON.stringify(values),
					edit_id: this.edit_id
				}).then(res => {
					if (!res.status) {
						this.$toast.fail(res.message)
					}
					this.get()
					this.$nextTick(() => {
						this.pic_files = []
						this.show_add = false
					})
				})
			},
			async onSubmitPic(e) {
				var list = e.pic_files;
				var datas = this.datas
				var idx = -1;
				var tmp_arr = []
				var j = 0;
				for (var i in datas) {
					j++;
					if (datas[i].id == this.edit_id) {
						tmp_arr = list
					}
				}
				for (var x = 0; x < list.length; x++) {
					list[x].status = 'uploading';
					list[x].message = '上传中...';
					await this.$ApiUtil.GroupCenterSrc.saveFile({
						pic: list[x].content,
						filename: typeof list[x].file == 'undefined' ? list[x].filename : list[x].file.name
					}).then(res => {
						list[x].status = 'done';
						list[x].message = '上传完成';
						if (!res.status) {
							if(res.message) this.$toast.fail(res.message)
							return;
						}
						list[x].url = res.url
						tmp_arr = this.pic_files
					})
				}
				var post_data = {
					switch_checked: e.switch_checked,
					is_match: e.is_match,
					pic_files: tmp_arr,
					keyword: this.keyword,
					title: this.title,
					mini_id: this.mini_id,
				}
			
				this.submit(post_data)
			},
			goBack() {
				this.$router.back()
			}
		}
	}
</script>
<style>
	.bottom-button {
		width: 160px;
		height: 40px;
	}
</style>
